import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import styles from "./Menu.module.css";
import { Container } from "@mui/material";

const Menu = () => {
  const navRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

   const location = useLocation();
  
    const handleNavClick = (e, path) => {
  
      if (location.pathname === path) {
        window.location.reload();
        window.scrollTo(0, 0);
        }
    };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isOpen && navRef.current && !navRef.current.contains(e.target)) {
        closeMenu();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);
  return (
    <header className={styles.header}>
      <Container maxWidth="xl">
        <div className={styles.container}>
          {/* Hamburger */}
          <div className={styles.hamburger} onClick={toggleMenu}>
            <span className={styles.bar}></span>
            <span className={styles.bar}></span>
            <span className={styles.bar}></span>
          </div>

          {/* Logo */}
          <Link to="/" className={styles.logo} onClick={(e) =>{handleNavClick(e, "/") }}>
            <span className={styles.desi}>Desi</span>
            <span className={styles.hisab}>Hisab</span>
          </Link>

          <div className={styles.rightSection}>
            {/* Slide-Out Nav */}
            <nav
              ref={navRef}
              className={`${styles.nav} ${isOpen ? styles.open : ""}`}
            >
              <span className={styles.closeIcon} onClick={closeMenu}>
                &times;
              </span>
              {["/", "/about", "/features", "/faqs", "/contactus"].map((path, idx) => {
                const labels = ["Home", "About", "Features", "FAQ", "Contact"];
                return (
                  <NavLink
                    key={path}
                    to={path}
                    className={({ isActive }) =>
                      `${styles.link} ${isActive ? styles.active : ""}`
                    }
                    end={path === "/"}
                    onClick={(e) =>{closeMenu();   handleNavClick(e, path) }}
                  >
                    {labels[idx]}
                  </NavLink>
                );
              })}
              <NavLink
                to="https://web.desihisab.com"
                className={`${styles.login} ${styles.mobileLogin}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                Login / Register
              </NavLink>
            </nav>

            {/* Desktop Login */}
            <div className={styles.mobileControls}>
              <NavLink
                to="https://web.desihisab.com"
                className={styles.login}
                target="_blank"
                rel="noopener noreferrer"
              >
                Login / Register
              </NavLink>
            </div>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Menu;
